import React from 'react';
import SourceSettingsRow from '@components/sources/source-view/source-settings/source-settings-row';
import Button from '@ui-library/button';
import useStores from '@stores/useStores';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';

interface Props {
  sourceId: string;
}
const SqlModelSettings: React.FC<Props> = ({ sourceId }: Props) => {
  const {
    modelListStore: { sourceModelMap },
  } = useStores();
  const sqlModelId = sourceModelMap[sourceId];
  if (!sqlModelId) {
    return (
      <SourceSettingsRow
        name="Model"
        description="Currently not using any model. Connect the source to a destination to start using model"
      />
    );
  }
  const { modelListStore } = useStores();
  const sqlModel = modelListStore.getModelById(sqlModelId);
  const history = useHistory();
  const moveToModelSettings = () => {
    history.push(`/models/${sqlModelId}?tab=Settings`);
  };
  return (
    <SourceSettingsRow
      name="Model "
      description={`Currently using the model ${sqlModel?.name}. Visit the model settings to change the settings like credentials`}
      cta={<Button secondary onClick={moveToModelSettings} name="Model Settings" />}
    />
  );
};
export default observer(SqlModelSettings);
